import Modal, { ModalBody, ModalHeader } from "components/bootstrap/Modal";
import { useTranslation } from "react-i18next";

/******************************************************************
 * 파일명 : frontend2\src\pages\CommonMenu\Login\components\PrivacyPolicyModal.js
 * 메뉴 : 로그인페이지 > 개인정보처리방침 모달
 * URL  :
 * 설명 : LoginNew.js의 언어 선택 드롭다운에서 고른 언어(ko/en/vi/ch)에 따라
 *        public/locales/{lng}/privacyPolicy.json 내용으로 자동 번역되어 표시됨
 ******************************************************************/

const PrivacyPolicyModal = ({ isPolicyModal, setIsPolicyModal }) => {
    const { t } = useTranslation();

    return(
        <Modal
            isOpen={isPolicyModal}
            setIsOpen={setIsPolicyModal}
            size='xl'
            isCentered
            isScrollable
            classNameProps='privacy_modal'
        >
            <ModalHeader setIsOpen={setIsPolicyModal}><h2 className='modal_tit'>{t('privacyPolicy.modalTitle')}</h2></ModalHeader>
            <ModalBody>
                <h3 className='h5 pt-2 fw-bold'>{t('privacyPolicy.article1.title')}</h3>
                <hr/>
                <p>{t('privacyPolicy.article1.intro')}</p>
                <h4 className='h6'>{t('privacyPolicy.article1.section1Title')}</h4>
                <ul>
                    <li>{t('privacyPolicy.article1.purpose')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article1.required')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article1.auto')}</li>
                </ul>

                <p>{t('privacyPolicy.article1.section2Title')}</p>
                <ul>
                    <li>{t('privacyPolicy.article1.optionalPurpose')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article1.optionalItems')}</li>
                </ul>

                <h3 className='h5 pt-2 fw-bold'>{t('privacyPolicy.article2.title')}</h3>
                <hr/>
                <p>{t('privacyPolicy.article2.p1')}</p>
                <p>{t('privacyPolicy.article2.p2')}</p>
                <ul>
                    <li>{t('privacyPolicy.article2.laborLaw')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article2.commAct')}</li>
                </ul>
                <p>{t('privacyPolicy.article2.p3')}</p>
                <ul>
                    <li>{t('privacyPolicy.article2.destroyProcess')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article2.destroyFull')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article2.destroyPartial')}</li>
                </ul>

                <h3 className='h5 pt-2 fw-bold'>{t('privacyPolicy.article3.title')}</h3>
                <hr/>
                <p>{t('privacyPolicy.article3.p1')}</p>
                <ul>
                    <li>{t('privacyPolicy.article3.entrustee')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article3.entrustedWork')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article3.storageLocation')}</li>
                </ul>
                <p>{t('privacyPolicy.article3.p2')}</p>
                <ul>
                    <li>{t('privacyPolicy.article3.transferee')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article3.transferDetail')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article3.transferItem')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article3.transferPurpose')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article3.refusal')}</li>
                </ul>

                <h3 className='h5 pt-2 fw-bold'>{t('privacyPolicy.article4.title')}</h3>
                <hr/>
                <p>{t('privacyPolicy.article4.p1')}</p>

                <h3 className='h5 pt-2 fw-bold'>{t('privacyPolicy.article5.title')}</h3>
                <hr/>
                <p>{t('privacyPolicy.article5.p1')}</p>
                <p>{t('privacyPolicy.article5.p2')}</p>

                <h3 className='h5 pt-2 fw-bold'>{t('privacyPolicy.article6.title')}</h3>
                <hr/>
                <p>{t('privacyPolicy.article6.technical')}</p>
                <p>{t('privacyPolicy.article6.managerial')}</p>

                <h3 className='h5 pt-2 fw-bold'>{t('privacyPolicy.article7.title')}</h3>
                <hr/>
                <p>{t('privacyPolicy.article7.p1')}</p>
                <p>{t('privacyPolicy.article7.p2')}</p>
                <ul>
                    <li>{t('privacyPolicy.article7.purpose')}</li>
                    <li className='mt-1'>{t('privacyPolicy.article7.refusal')}</li>
                </ul>

                <h3 className='h5 pt-2 fw-bold'>{t('privacyPolicy.article8.title')}</h3>
                <hr/>
                <p>{t('privacyPolicy.article8.officerSectionTitle')}</p>
                <ul>
                    <li>{t('privacyPolicy.article8.nameLabel')} : {t('privacyPolicy.article8.officerName')}</li>
                    <li>{t('privacyPolicy.article8.positionLabel')} : CPO</li>
                    <li>{t('privacyPolicy.article8.rankLabel')} : {t('privacyPolicy.article8.officerRank')}</li>
                    <li>{t('privacyPolicy.article8.emailLabel')} : <a href="mailto:jh.oh@metanet.co.kr">jh.oh@metanet.co.kr</a></li>
                </ul>
                <p>{t('privacyPolicy.article8.deptSectionTitle')}</p>
                <ul>
                    <li>{t('privacyPolicy.article8.deptLabel')} : HCT</li>
                    <li>{t('privacyPolicy.article8.managerLabel')} : {t('privacyPolicy.article8.deptManagerName')}</li>
                    <li>{t('privacyPolicy.article8.rankLabel')} : {t('privacyPolicy.article8.officerRank')}</li>
                    <li>{t('privacyPolicy.article8.emailLabel')} : <a href="mailto:cslee@metanet.co.kr">cslee@metanet.co.kr</a></li>
                </ul>

                <h3 className='h5 pt-2 fw-bold'>{t('privacyPolicy.article9.title')}</h3>
                <hr/>
                <p>{t('privacyPolicy.article9.p1')}</p>
            </ModalBody>
        </Modal>
    )
}

export default PrivacyPolicyModal;
